import { 
  QuestionMarkCircleIcon,
  CurrencyDollarIcon,
  ShieldCheckIcon
} from '@heroicons/react/24/outline';

export const faqSections = [
  {
    id: 'getting-started',
    title: 'Getting Started',
    icon: QuestionMarkCircleIcon,
    questions: [
      {
        question: "What is RentFi?",
        answer: "RentFi is a blockchain-based real estate investment platform that enables monthly passive income through professionally managed properties. With RENT, investors gain access to a curated portfolio of high-yield properties, receiving monthly rental income distributions and benefiting from property value appreciation."
      },
      {
        question: "How do I start investing?",
        answer: "Starting with RentFi is simple: Purchase RENT tokens on Raydium and automatically receive monthly rental income distributions proportional to your holdings. No staking or complex setup required."
      },
      {
        question: "What are RENT tokens?",
        answer: "RENT are Solana-based digital assets that give fractional monthly dividends in RentFi's real estate portfolio. Each token entitles holders to a proportional share of monthly rental income distributions and voting rights in the RentFi DAO. Tokens can be freely traded on Raydium."
      }
    ]
  },
  {
    id: 'investment-process',
    title: 'Investment Process',
    icon: CurrencyDollarIcon,
    questions: [
      {
        question: "What is the minimum requirement to qualify for passive income?",
        answer: "To qualify for monthly rental income distributions, you must hold a minimum of 1,000 RENT tokens in your wallet and maintain your token holdings for at least 15 days. These requirements ensure fair distribution, ecosystem sustainability, and reward committed participants in the RentFi community. Distributions are automatically calculated based on your token holdings and sent directly to qualifying wallets."
      },
      {
        question: "How is rental income distributed?",
        answer: "RentFi uses a unique 50/50 mechanism: 50% of net rental profits are used to buy RENT from the market and distributed as passive income to eligible holders, while the other 50% is used to buy and burn RENT tokens, reducing supply and increasing scarcity over time."
      },
      {
        question: "Do I need to stake my RENT to earn rental income?",
        answer: "No, staking is not required. Simply holding at least 1,000 RENT in your Solana-compatible wallet for a minimum of 15 days automatically qualifies you for monthly rental income distributions. Your tokens remain liquid and accessible at all times, while the holding period ensures fair distribution."
      }
    ]
  },
  {
    id: 'technical',
    title: 'Technical & Security',
    icon: ShieldCheckIcon,
    questions: [
      {
        question: "Where does RentFi trade?",
        answer: "RENT tokens can be traded on Raydium using the RENT/SOL trading pair. Thanks to Solana's high-speed blockchain, transactions are fast and fees are minimal."
      },
      {
        question: "How do you ensure the security of investments?",
        answer: "RentFi implements multiple security measures including a fixed token supply (100M RENT), regular token burns, strategic liquidity pools, and transparent on-chain transactions. All property details and financial operations are publicly verifiable."
      },
      {
        question: "Can I convert my rental income to fiat currency?",
        answer: "Yes, you can convert your RENT tokens to fiat currency through a simple process: swap RENT for SOL on Raydium, then use trusted fiat off-ramp services like Transak to convert to your preferred currency."
      }
    ]
  }
];